/* global axios */
import ApiClient from './ApiClient';

class DataImportsAPI extends ApiClient {
  constructor() {
    super('data_imports', { accountScoped: true });
  }

  // Lê a planilha só pra montar o mapeamento. Não grava nada no servidor: o
  // arquivo sobe de novo no `start`, quando a pessoa confirma.
  preview(file, dataType) {
    const form = new FormData();
    form.append('import_file', file);
    form.append('data_type', dataType);

    return axios.post(`${this.url}/preview`, form);
  }

  start({ file, dataType, mapping, settings }) {
    const form = new FormData();
    form.append('import_file', file);
    form.append('data_type', dataType);
    form.append('mapping', JSON.stringify(mapping || {}));
    form.append('settings', JSON.stringify(settings || {}));

    return axios.post(this.url, form);
  }

  list() {
    return axios.get(this.url);
  }
}

export default new DataImportsAPI();
